<script setup lang="ts">
import { ref } from 'vue';
import { locale } from '../../locale';
import ToolTip from '../ToolTip.vue';

const btn = ref<HTMLElement | null>(null)
</script>
<template>
  <button ref="btn" class="setting-button">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.328 12.9375C19.3699 12.6266 19.3924 12.3135 19.3954 12C19.3924 11.6865 19.3699 11.3734 19.328 11.0625L21.4113 9.47345C21.5054 9.40344 21.5697 9.30209 21.5919 9.1888C21.6141 9.07551 21.5926 8.95823 21.5316 8.85938L19.559 5.52658C19.5018 5.42661 19.4091 5.35046 19.2984 5.31247C19.1876 5.27447 19.0664 5.27727 18.9575 5.32033L16.499 6.28595C15.9874 5.90555 15.4279 5.5905 14.8343 5.34846L14.4638 2.80315C14.4474 2.69052 14.3896 2.58752 14.3011 2.51335C14.2126 2.43918 14.0994 2.3989 13.9827 2.40002H10.0278C9.91101 2.3989 9.79782 2.43918 9.7093 2.51335C9.62078 2.58752 9.56296 2.69052 9.54662 2.80315L9.17615 5.34846C8.58171 5.58899 8.02207 5.90416 7.51144 6.28595L5.04324 5.32033C4.93443 5.27727 4.81321 5.27447 4.70243 5.31247C4.59165 5.35046 4.49896 5.42661 4.44183 5.52658L2.46919 8.85938C2.40819 8.95823 2.38673 9.07551 2.40892 9.1888C2.43111 9.30209 2.4954 9.40344 2.58947 9.47345L4.66796 11.0625C4.62621 11.3734 4.60371 11.6865 4.6006 12C4.60355 12.3135 4.62604 12.6266 4.66796 12.9375L2.58947 14.5266C2.4954 14.5966 2.43111 14.6979 2.40892 14.8112C2.38673 14.9245 2.40819 15.0418 2.46919 15.1406L4.44183 18.4734C4.49896 18.5734 4.59165 18.6495 4.70243 18.6875C4.81321 18.7255 4.93443 18.7227 5.04324 18.6797L7.50182 17.714C8.01341 18.0944 8.57285 18.4095 9.16653 18.6515L9.537 21.1969C9.55334 21.3095 9.61116 21.4125 9.69968 21.4867C9.7882 21.5608 9.90138 21.6011 10.0181 21.6H13.9634C14.0802 21.6011 14.1933 21.5608 14.2819 21.4867C14.3704 21.4125 14.4282 21.3095 14.4445 21.1969L14.815 18.6515C15.4094 18.411 15.9691 18.0958 16.4797 17.714L18.9383 18.6797C19.0471 18.7227 19.1683 18.7255 19.2791 18.6875C19.3899 18.6495 19.4826 18.5734 19.5397 18.4734L21.5123 15.1406C21.5733 15.0418 21.5948 14.9245 21.5726 14.8112C21.5504 14.6979 21.4861 14.5966 21.3921 14.5266L19.328 12.9375ZM12.0004 15.3656C11.3169 15.3665 10.6486 15.1699 10.0799 14.8007C9.51113 14.4314 9.06761 13.9061 8.8054 13.2912C8.5432 12.6763 8.4741 11.9995 8.60685 11.3463C8.7396 10.6931 9.06823 10.093 9.55116 9.62181C10.0341 9.15065 10.6496 8.82964 11.3199 8.6994C11.9901 8.56916 12.6849 8.63553 13.3165 8.89013C13.948 9.14473 14.4878 9.57611 14.8676 10.1297C15.2474 10.6833 15.4501 11.3341 15.4501 12C15.4507 12.4418 15.362 12.8793 15.1889 13.2876C15.0158 13.6959 14.7618 14.067 14.4414 14.3796C14.121 14.6922 13.7405 14.9401 13.3216 15.1093C12.9028 15.2785 12.4538 15.3656 12.0004 15.3656Z"
        stroke="#292929" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    <ToolTip :placement="'top'" :reference="btn">{{locale.settings}}</ToolTip>
  </button>
</template>
<style scoped>
.setting-button {
  width: 36px;
  height: 36px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background-color: rgba(236, 236, 236, 0.85);
  border-radius: 50px;
  border: none;
  cursor: pointer;
}

.setting-button:hover {
  background-color: #F6F6F6;
}

.setting-button:active {
  background-color: #DBDBDB;
}

.setting-button:focus {
  outline: none;
}
</style>
